// *******************************************************
// Scores Export File
// -------------------------------------------------------
// All Moosh Score Faces
// -------------------------------------------

// *******************************************
// Exports
// -------------------------------------------
import * as Sad_ from './Sad';
import * as Neutral_ from './Neutral';
import * as Happy_ from './Happy';
// --------------------------------

// *******************************************
// Exports
// -------------------------------------------
export const Happy = Happy_;
export const Neutral = Neutral_;
export const Sad = Sad_;
// --------------------------------



// WEBPACK FOOTER //
// ./src/components/Face/index.js